await loadComponent('./components/mc-element.js', false);

await loadComponent('./res/mc-utils.js', false);
await loadComponent('./res/mc-events.js', false);
await loadComponent('./res/mc-shopify.js', false);

class MobileMenu extends McElement {

  connectedCallback() {
    if (typeof bootstrap === 'undefined') {
      setTimeout(() => this.addEvent(), 100);
    } else {
      this.addEvent();
    }
  }

  addEvent() {
    const oc   = document.getElementById('mobileMenu');
    if (!oc) return;

    try {
      if (typeof bootstrap !== 'undefined' && bootstrap.Offcanvas) {
        const bsOffcanvas = bootstrap.Offcanvas.getOrCreateInstance(oc, {
          backdrop: true,
          keyboard: true,
          scroll: false
        });
      }
    } catch (e) {
      console.log('Bootstrap Offcanvas initialization:', e);
    }

    oc.querySelectorAll('[data-mm-target]').forEach(btn => {
        btn.addEventListener('click', () => {
        document.getElementById(btn.dataset.mmTarget).classList.remove('d-none');
        });
    });

    oc.querySelectorAll('[data-mm-back]').forEach(btn => {
        btn.addEventListener('click', () => {
        btn.closest('.mm-submenu').classList.add('d-none');
        });
    });

    oc.addEventListener('hidden.bs.offcanvas', () => {
        oc.querySelectorAll('.mm-submenu').forEach(el => el.classList.add('d-none'));
    });
  }
}

if (!customElements.get('mobile-menu')) {
  
  customElements.define('mobile-menu', MobileMenu);
}
window.MobileMenu = MobileMenu;